const endpoints = {
  // local

  // serverBaseUrl: "http://localhost:1010/",
  // serverBaseUrl: "http://3.108.53.19:5000/",
  // serverBaseUrl:
  //   "http://ec2-3-108-53-19.ap-south-1.compute.amazonaws.com:5000/",
  // serverBaseUrl: "https://gsm-server123.onrender.app/",
  // serverBaseUrl: "https://gsmdev123.onrender.com/",
  // serverBaseUrl: "https://backend.gsmtradinginstitute.com/",
  // serverBaseUrl: "https://backend.gsmtradinginstitute.com/",
  serverBaseUrl: "https://backend.gsmtradinginstitute.com/",
  razorpayId: "rzp_test_t6ArxAcVBAShgb",

  //
  // serverBaseUrl: "https://gsm-training-institute-server.onrender.com/",
};

export default endpoints;
